module.exports = __webpack_public_path__ + "1725072f4e8f716ccef6081e86236438.svg";